import type { ReactElement } from 'react'
import styled from 'styled-components'

import { Accordion } from '@/components/elements/Accordion'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
import { Paragraph } from '@/components/layouts/Ir/Paragraph'
import { PDFList } from '@/components/layouts/Ir/PDFList'

const midTermPlanDocument = {
  id: '20260212-a15f286d',
  fileName: '中期経営計画(2027年6月期～2029年6月期)　2026/02/12 公表',
  filePath: 'https://pdf.irpocket.com/C141A/xoA3/IjHJ/JWlA/RxC9.pdf',
}

const midTermPlanPdfGroups = [
  {
    accordionTitle: '2027年6月期～2029年6月期',
    accordionItems: [midTermPlanDocument],
    isDefaultOpen: true,
  },
]

const midTermPlanDescription =
  '当社は、2027年６月期から2029年６月期を最終年度とする３ヵ年の中期経営計画を策定いたしました。\n\n' +
  '当中期経営計画においては、西友のPMIを着実に推進し、シナジー創出を軸としたキャッシュ創出力の向上によって財務健全性を高めるとともに、 次世代フォーマットの成功モデルの確立など、2030年６月期以降の更なる成長に向けた事業基盤を構築してまいります。'

export const MidTermPlan = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Medium-Term Management Plan"
        subTitleText="中期経営計画"
      />
      <PlanImage
        src="/images/ir-library-medium-term-plan.jpg"
        alt=""
        width="2020"
        height="1120"
      />
      <PlanDescription>{midTermPlanDescription}</PlanDescription>
      <Spacer h={{ sp: 70, pc: 120 }} />
      <AccordionArea>
        {midTermPlanPdfGroups.map((value, index) => (
          <div key={`${index}${value.accordionTitle}`}>
            <Accordion
              accordionTitle={value.accordionTitle}
              contentsLength={value.accordionItems.length}
              isDefaultOpen={value.isDefaultOpen}
            >
              <PDFList pdfList={value.accordionItems} />
            </Accordion>
          </div>
        ))}
      </AccordionArea>
    </Layout>
  )
}

MidTermPlan.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: '経営方針', path: '/ir/library/' },
    { name: '中期経営計画', path: '' },
  ]

  return (
    <>
      <Head
        title="中期経営計画"
        description="トライアルホールディングスグループの中期経営計画を掲載しています。"
        ogp={{ url: 'ir/library/midtermplan/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}

const AccordionArea = styled(Paragraph).attrs({ as: 'section' })`
  display: flex;
  flex-direction: column;
  gap: 50px;
  width: 100%;
`

const PlanImage = styled.img`
  display: block;
  width: 100%;
  max-width: 682px;
  height: auto;
  margin: 30px auto 0;
`

const PlanDescription = styled(Paragraph)`
  width: 100%;
  margin: 24px 0 0;
  color: #333;
  letter-spacing: 0;
  white-space: pre-line;
`
